import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface LoadingStateProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Text to display while loading
   */
  text?: string;
  
  /**
   * Size of the loading spinner
   */
  size?: 'sm' | 'md' | 'lg';
  
  /**
   * Whether to center the loading state
   */
  centered?: boolean;
  
  /**
   * Whether to show a full-page loading overlay
   */
  fullPage?: boolean;
}

/**
 * A reusable loading state component
 */
export function LoadingState({
  text = 'Loading...',
  size = 'md',
  centered = true,
  fullPage = false,
  className,
  ...props
}: LoadingStateProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };
  
  const containerClasses = cn(
    'flex items-center gap-2',
    centered && 'justify-center',
    fullPage && 'fixed inset-0 bg-background/80 backdrop-blur-sm z-50',
    className
  );
  
  return (
    <div className={containerClasses} {...props}>
      <Loader2 className={cn('animate-spin', sizeClasses[size])} />
      {text && <p className="text-muted-foreground">{text}</p>}
    </div>
  );
} 